import { useCallback, useState } from 'react'

export const useUserDropdown = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const toggleDropdown = useCallback(() => {
    setIsDropdownOpen((prev) => !prev)
  }, [])

  return {
    isDropdownOpen,
    toggleDropdown,
  }
}
